/**
 * iOS 18.5 foreground fallback (PART 3, раздел 6).
 *
 * Production canary: push на iPhone доставляется, но tap может просто вернуть
 * уже открытую Home Screen PWA на прежнюю страницу. Поэтому при возврате из
 * background приложение само проверяет, не появилось ли новое нарушение, и
 * показывает баннер. Это дополнение к системному push, а не его замена:
 * автоматического перехода здесь нет и быть не должно.
 */

export const FALLBACK_KEYS = {
  LAST_HANDLED_EVENT: 'violations.lastHandledEventId',
  LAST_BACKGROUND_AT: 'violations.lastBackgroundAt',
  PUSH_ONBOARDING_DISMISSED: 'violations.pushOnboardingDismissed',
};

export const isStandalonePwa = () => {
  if (typeof window === 'undefined') return false;
  return window.navigator.standalone === true
    || window.matchMedia?.('(display-mode: standalone)').matches === true;
};

export const readStored = (key) => {
  try {
    return window.localStorage.getItem(key) || '';
  } catch (error) {
    // Приватный режим Safari умеет бросать на localStorage — это не повод падать.
    return '';
  }
};

export const writeStored = (key, value) => {
  try {
    window.localStorage.setItem(key, String(value));
  } catch (error) {
    /* namespace недоступен — работаем без памяти между сессиями */
  }
};

/**
 * Баннер показывается, только если приложение действительно уходило в
 * background, событие новее этого момента и его ещё не показывали. Закрытый
 * баннер не возвращается: lastHandledEventId запоминается при закрытии.
 */
export const shouldShowViolationBanner = ({ event, lastHandledEventId, lastBackgroundAt } = {}) => {
  if (!event?.id) return false;
  if (!lastBackgroundAt) return false;
  if (String(event.id) === String(lastHandledEventId || '')) return false;

  const moment = event.confirmed_at || event.started_at;
  if (!moment) return true;

  const eventTime = new Date(moment).getTime();
  const backgroundTime = new Date(lastBackgroundAt).getTime();
  if (!Number.isFinite(eventTime) || !Number.isFinite(backgroundTime)) return true;

  return eventTime > backgroundTime;
};
